import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success("If that account exists, we just sent a reset link.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="max-w-md mx-auto px-4 py-12">
        <div className="brand-card p-8 sm:p-10">
          <div className="overline mb-3">Forgot your password?</div>
          <h1 className="text-3xl font-extrabold text-[#3D405B] tracking-tight">No worries — we'll help.</h1>
          <p className="text-sm text-[#7A7D96] mt-2">Enter your email and we'll send a link to set a new password. The link expires in one hour.</p>

          {done ? (
            <div className="mt-6 p-4 rounded-2xl bg-secondary/10 border border-secondary/20 text-[#3D405B]" data-testid="forgot-done">
              If an account exists for <strong>{email}</strong>, a reset link is on its way. Please check your inbox (and spam folder).
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-4 mt-6">
              <div>
                <label className="block text-xs font-bold text-[#3D405B] uppercase tracking-wider mb-2">Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 rounded-2xl bg-white border border-[#3D405B]/15 focus:ring-2 focus:ring-primary/40 focus:border-primary outline-none transition-all"
                  placeholder="you@example.com"
                  data-testid="forgot-email-input"
                />
              </div>
              <button type="submit" disabled={submitting} className="w-full px-5 py-3 rounded-full bg-primary text-white font-bold shadow-md hover:-translate-y-0.5 hover:shadow-lg transition-all disabled:opacity-60" data-testid="forgot-submit-btn">
                {submitting ? "Sending…" : "Send reset link"}
              </button>
            </form>
          )}

          <p className="text-sm text-center text-[#7A7D96] mt-6">
            Remembered it? <Link to="/login" className="text-primary font-bold hover:underline">Sign in</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
